import { Button } from "@mui/material";
import { styled } from "@mui/system";

export const StyledSaveCloseContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  [theme.breakpoints.up("sm")]: {
    position: "static",
    padding: 0,
    textAlign: "center"
  },
  "&.hideSaveCloseBtn": {
    display: "none!important"
  },
  "& .saveButtonContainer": {
    marginLeft: "auto",
    [theme.breakpoints.up("sm")]: {
      marginLeft: 0
    }
  },
  "& .saveCloseLabel": {
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "2px",
    color: "#757575",
    [theme.breakpoints.up("sm")]: {
      fontSize: "0.875rem",
      lineHeight: "18px"
    }
  },

  "& .saveCloseProgressContainer": {
    marginLeft: "19px",
    marginTop: "0px",
    [theme.breakpoints.up("sm")]: {
      marginLeft: "0px",
      marginTop: "0px"
    }
  },

  "& .progressLayout": {
    display: "inline-flex",
    gap: "2px",
    [theme.breakpoints.up("sm")]: {
      gap: "unset"
    }
  },

  "& .circularProgress": {
    width: "8px !important",
    height: "8px !important",
    color: "black",
    [theme.breakpoints.up("sm")]: {
      width: "14px !important",
      height: "14px !important",
      display: "block",
      color: "black",
      marginRight: "8px",
      marginTop: "2px"
    }
  }
}));

export const StyledSaveCloseButton = styled(Button)(({ theme }) => ({
  width: "139px",
  height: "18px",
  border: "none",
  fontSize: "0.875rem",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "18px",
  textTransform: "none",

  [theme.breakpoints.up("sm")]: {
    width: "auto",
    fontSize: "1.25rem",
    fontWeight: 500,
    lineHeight: "28px"
  },
  "&:hover": {
    border: "none"
  },
  "&.hideSaveCloseBtn": {
    display: "none!important"
  }
}));
